import type { Bootcamp, BootcampDelivery, Community } from "$lib/datamodel";
import { derived, type Readable, type Writable } from "svelte/store";
import { community } from "./nucamp-community";
import { currentBootcamp } from "./nucamp-currentbootcamp";
import { getNextBootcampDeliverybyBootcamp } from "../services/bootcamp";

export const bootcampDelivery = derived<[Readable<Community | null>, Writable<Bootcamp | null>], BootcampDelivery | null>([community, currentBootcamp], ([$community, $currentBootcamp], set) => {
  if ($community?.id && $currentBootcamp?.id) {
    getNextBootcampDeliverybyBootcamp($currentBootcamp.id, $community.id)
      .then((data: BootcampDelivery) => {
        if (data?.id) set(data);
      });
  }
});